/** @jsx jsx */
/** @jsxFrag React.Fragment */
import { colors } from '@apollo/space-kit/colors';
import { Rocket2 } from '@apollo/space-kit/illustrations/Rocket2';
import { jsx } from '@emotion/react';
import React from 'react';

import { isEmbeddableExplorerRoute } from 'src/app/embeddableExplorer/isEmbeddableExplorerRoute';
import { isEmbeddableSandboxRoute } from 'src/app/embeddableSandbox/isEmbeddableSandboxRoute';

import {
  SandboxLogInButton,
  SandboxSignUpButtons,
} from '../../sandboxShared/SandboxSignUpButtons';

export const OperationCollectionsLogInPrompt = () => {
  const isEmbedded = isEmbeddableExplorerRoute() || isEmbeddableSandboxRoute();

  return (
    <div className="flex flex-col items-center text-center">
      <div className="mt-8 flex flex-col items-center">
        <Rocket2
          className="w-40 text-transparent"
          css={{
            '[fill="#F18686"]': {
              fill: 'transparent',
            },
            '[fill="#74B0F4"]': {
              fill: 'transparent',
            },
            '[stroke="#464646"]': {
              stroke: colors.blilet.light,
            },
            'g.stars, g[fill-rule="evenodd"] > g': {
              'path[fill="#CAD0D8"]': {
                fill: 'transparent',
                stroke: colors.blilet.base,
              },
              'circle[fill="#CAD0D8"]': {
                fill: colors.blilet.base,
              },
            },
          }}
        />{' '}
        <div className="mt-4 text-lg">Log in to your Studio account</div>
        <div className="text-base text-secondary">
          to save operations in your Sandbox
        </div>
        <SandboxLogInButton
          userSegmentType="sandbox_operation_collections"
          className="mt-8"
        />
      </div>
      {!isEmbedded && (
        <>
          <hr className="my-10 flex w-5/6 border-primary" />
          <div className="flex w-full flex-col items-center">
            <div className="text-lg">Or sign up for Studio</div>
            <div className="mb-8 w-5/6 text-center text-base text-secondary">
              to register your graph, save operations, run checks, see metrics,
              and so much more...{' '}
            </div>
            <SandboxSignUpButtons
              iconOnly
              userSegmentType="sandbox_operation_collections"
            />
          </div>
        </>
      )}
    </div>
  );
};
